import { LogEntriesAccordianListCombinedProps } from './types';

const usePresenter = (props: LogEntriesAccordianListCombinedProps): LogEntriesAccordianListCombinedProps => {
  return props;
};

export default usePresenter;
